import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core'
import { GbPrivacyPolicyDialogComponent } from 'libs/gb-front/account/ui/src/lib/gb-privacy-policy-dialog/gb-privacy-policy-dialog.component'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src'
import { UseTagsEnum } from 'libs/gb-front/auction/util/src/lib/gb-auction-meta/gb-auction-meta.models'
import { GbAuctionMetaService } from 'libs/gb-front/auction/util/src/lib/gb-auction-meta/gb-auction-meta.service'
import { GbFrontDialogService } from 'libs/gb-front/shared/util/src'
@Component({
  selector: 'gb-login',
  templateUrl: './gb-login.component.html',
  styleUrls: ['./gb-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbLoginComponent implements OnInit, OnDestroy {
  auction$ = this.auctionFacade.auction$
  displaySocialLogin$ = this.auctionFacade.displaySocialLogin$

  constructor(
    private auctionFacade: AuctionFacade,
    private gbFrontDialogService: GbFrontDialogService,
    private gbAuctionMetaService: GbAuctionMetaService,
  ) {}

  ngOnInit(): void {
    this.gbAuctionMetaService.useTagSubject$.next(UseTagsEnum.Login)
  }

  ngOnDestroy(): void {
    this.gbAuctionMetaService.useTagSubject$.next(UseTagsEnum.Auction)
  }

  openPrivacyPolicy(): void {
    this.gbFrontDialogService.openDialog(GbPrivacyPolicyDialogComponent)
  }
}
